import { IconProps } from "../../utils/global-types/global-types";

const MarketingConsentIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-3 h-3"}
    {...rest}
  >
    <g clipPath="url(#mc_clip)">
      <path
        d="M6 0C2.692 0 0 2.692 0 6s2.692 6 6 6 6-2.692 6-6S9.308 0 6 0m3.353 4.421-3.834 3.805a.74.74 0 0 1-1.034.015L2.662 6.391a.755.755 0 0 1-.046-1.053.744.744 0 0 1 1.053-.037L5.068 6.992l3.428-3.428a.758.758 0 0 1 1.072 0 .758.758 0 0 1-.215 1.072z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="mc_clip">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MarketingConsentIcon;
